import { Link } from "react-router-dom";
import { Clock, Wallet, CalendarDays, MapPin } from "lucide-react";
import { ClinqLogo } from "../ClinqLogo";

const DETAILS = [
  { icon: Clock, label: "Duration", value: "1.5 hours" },
  { icon: Wallet, label: "Investment", value: "KES 12,500" },
  { icon: CalendarDays, label: "Available slots", value: "Mondays & Thursdays 2:00pm – 3:30pm · Tuesdays & Wednesdays 8:00am – 9:30am" },
  { icon: MapPin, label: "Format", value: "Virtual or in-person at SNDBX International, Hurlingham, Nairobi" },
];

export const DiscoveryHero = () => (
  <section className="relative overflow-hidden bg-[#0B2A28] text-white" data-testid="discovery-hero">
    <div className="pointer-events-none absolute -right-32 -top-32 h-[520px] w-[520px] rounded-full bg-[#0A8B85]/25 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-40 left-1/4 h-[420px] w-[420px] rounded-full bg-[#E3B84C]/10 blur-3xl" />
    <header className="relative mx-auto flex max-w-6xl items-center justify-between px-5 py-6">
      <Link to="/" data-testid="discovery-logo-link"><ClinqLogo size="lg" tone="white" /></Link>
      <span className="rounded-full border border-[#E3B84C]/50 bg-[#E3B84C]/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-[#E3B84C]">Clinq Advisory</span>
    </header>
    <div className="relative mx-auto max-w-6xl px-5 pb-16 pt-8 sm:pb-20 sm:pt-12">
      <h1 className="max-w-4xl text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid="discovery-heading">
        Book a Discovery Session with <span className="text-[#7BD3CE]">Doreen Zaki</span>
      </h1>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#B9D9D6] md:text-lg" data-testid="discovery-subheading">
        An in-depth dive into your business and a clear path to capital readiness — in one focused session.
      </p>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-testid="discovery-details">
        {DETAILS.map(({ icon: Icon, label, value }) => (
          <div key={label} className="rounded-2xl border border-white/10 bg-white/[0.05] p-5 backdrop-blur" data-testid={`discovery-detail-${label.toLowerCase().replace(/\s+/g, "-")}`}>
            <Icon size={20} className="text-[#E3B84C]" />
            <p className="mt-3 text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#7BD3CE]">{label}</p>
            <p className="mt-1.5 text-sm font-semibold leading-relaxed text-white sm:text-base">{value}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
